export default "__VITE_PUBLIC_ASSET__ff415124__"